<template>
<div id="contentview" v-html="compiledMarkdown">

</div>
</template>
<style>
#contentview h2 {
    border-bottom: solid 3px #083674;
    font-size: 1.5em;
    font-weight: bold;
    margin: 10px 0 20px;
    padding: 0 0 8px;
    font-family: inherit;
    color: inherit;
    box-sizing: border-box;
    display: block;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    text-align: justify;
    -webkit-tap-highlight-color: transparent;
}

.voice-icon .icon1 {
    background: url("../assets/img/soundplay.png") no-repeat;
    background-size: 20px;
}

.static-wrap h2 {
    border-bottom: solid 3px #083674;
    font-size: 1.5em;
    font-weight: bold;
    margin: 10px 0 20px;
    padding: 0 0 8px;
}

.h2,
h2 {
    font-size: 2rem;
}
.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
    margin-bottom: 0.5rem;
    font-family: inherit;
    font-weight: 400;
    line-height: 1.2;
    color: inherit;
}
h1,
h2,
h3,
h4,
h5,
h6 {
    margin-top: 0;
    margin-bottom: 0.5rem;
}
*,
:after,
:before {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
*,
:after,
:before {
    box-sizing: border-box;
}
user agent stylesheet h2 {
    display: block;
    font-size: 1.5em;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
}
.static-wrap h3 {
    position: relative;
    padding: 0.5em 0.2em 0.5em 1.4em;
    margin: 20px 0 10px;
    font-size: 1.3em;
    font-weight: bold;
    border: 1px solid #cacaca;
    background: #f4f4f4;
}
.static-wrap h3:after {
    position: absolute;
    top: 0.35em;
    left: 0.5em;
    content: "";
    width: 6px;
    height: -webkit-calc(100% - 0.8em);
    height: calc(100% - 0.8em);
    background-color: #226296;
    border-radius: 4px;
}
</style>
<script>
var marked = require('marked');
import store from '../store'
import {CONTENTS_SRV} from '@/services/config'

window.soundPlay = function (sound, id) {
  var soundid = '#sound_' + id;
  var audio = new Audio(sound);
  //$("#sound_" + id).children('img').attr('src', '/img/soundplay.gif');
  audio.play();
  audio.addEventListener("ended", function(){
    //$("#sound_" + id).children('img').attr('src', '/img/soundplay.png');
	}, false);
} 

export default {
  name: 'ContentView',
  props: {
    content: String
  },
  computed: {
    compiledMarkdown: function () {
      var self = this;
      //return marked(self.$store.getters.content, { breaks: true })
   
        // レンダラーを取得
      let renderer = new marked.Renderer()

      // Heading 要素のレンダラーを拡張
      renderer.heading = function (text, level, raw) {
        const regex = /\s*{{(.*)}}/
        const addon = raw.match(regex) ? raw.match(regex)[1] : ''
        return `<h${level} ${addon}>${text.replace(regex, '')}</h${level}>\n`
      }

      renderer.image = function (href, title, text) {
        
        var arr = href.split("/");
        var filename = arr[arr.length-1];
        var fileext = filename.split(".");
        var id = fileext[0];
        var out = '';
        var ext = fileext[fileext.length - 1].toLocaleLowerCase();
        if (['png', 'jpg', 'jpeg', 'gif'].includes(ext)) {
          out = `<img src="${CONTENTS_SRV}` + href + '" alt="' + text + '"';
          if (title) {
            out += ' title="' + title + '"';
          }
          out += this.options.xhtml ? '/>' : '>';
        }
        else if (['mp3'].includes(ext)) {
          out = '<a id="sound_'+id+'" class="soundplay" href="#" onClick="soundPlay(\'' +`${CONTENTS_SRV}` + href + '\',\'' + id + '\')" ';
          if (title) {
            out += ' title="' + title + '"';
          }
          out += this.options.xhtml ? '/>' : '>';
          out += `<img style="width:30px" src="/images/soundplay.png"></a>`;
        }
 
        return out;
      };

        this.$nextTick(function(){
        //    this.$forceUpdate();
        });
        return marked(self.$store.getters.content, { renderer: renderer, sanitize: false , breaks: true}) 
   
   
   }
  },
  data:function(){
      return {
          voiceImage: require("../assets/img/soundplay.png"),
          input:'## aaa'
      }
  }  ,


}
</script>